import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@core/App';

const legacyHostRedirectMap: Record<string, string> = {
    'en-gpt-local.eon.com': 'bag-gpt-local.bayernwerk.de',
    'en-gpt-dev.eon.com': 'bag-gpt-dev.bayernwerk.de',
    'en-gpt-qas.eon.com': 'bag-gpt-qas.bayernwerk.de',
    'en-gpt.eon.com': 'bag-gpt.bayernwerk.de',
};

const targetHost = legacyHostRedirectMap[window.location.hostname];
if (targetHost) {
    const { pathname, search, hash } = window.location;
    window.location.replace(`https://${targetHost}${pathname}${search}${hash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
